import { getClassNameForField, reportFields as fields } from '../../constants'
import { useTranslationService } from '../../util/TranslationContext'
import { EditableFormPage } from '../components/EditableFormPage'
import { useParams } from 'react-router-dom'

const ReportsSlug = () => {
    const { id } = useParams()

    const { translateFields } = useTranslationService()
    const reportFields = translateFields(fields, 'reports')

    return (
        <>
            <EditableFormPage
                fetchUrl={`admin/manage-donations/${id}`}
                fields={reportFields}
                classNameForField={getClassNameForField}
                acceptJSON={true}
                method='PUT'
                readOnly={true}
            />
        </>
    )
}

export default ReportsSlug
